import React, { useEffect } from "react";
import "./App.css";

import { Provider } from 'react-redux';
import store from "redux/store";
import MainPage from "pages/MainPage";
import Header from "components/comp/Header";
import DetailCompanyIntro from "pages/DetailCompanyIntro";
import Footer from "components/comp/Footer";
import { Route, Routes, useLocation, Navigate } from "react-router-dom";
import Location from "pages/Location";
import Notice from "pages/Notice"
import Recruit from "pages/Recruit";
import BoardArticle from "components/comp/BoardArticle";
import RodCuttingAlgo from "pages/RodCuttingAlgo";
// 2-depth dedicated pages
// removed: greeting/business merged into overview
import AboutOverview from "pages/about/Overview";
import AboutHistory from "pages/about/History";
// removed: direction/strategy/service merged into maintenance
import CompProcess from "pages/competency/Process";
import CompConfig from "pages/competency/Config";
import CompMaintenance from "pages/competency/Maintenance";
import CompHyGateOne from "pages/competency/HyGateOne";
import ProductHyGateOne from "pages/product/HyGateOne";
import ProductScheduler from "pages/product/Scheduler";
import ProductRodCutting from "pages/product/RodCutting";
import RecruitPlan from "pages/recruit/Plan";
import SupportNews from "pages/support/News";
import SupportQuestions from "pages/support/Questions";

let currentPath = "";

function App() {

  let location = useLocation();
  
  //링크 재클릭시 화면 최상단으로 이동시키기위해
  useEffect(() => {

    const refreshList = ["/recruit","/notice"];
    
    if(currentPath === location.pathname) {
      
      //공지사항이나 채용정보 게시판에서 링크 재클릭시 새로고침
      if(refreshList.includes(currentPath)){
        window.location.reload();
      }else window.scrollTo(0, 0);
    }
    currentPath = location.pathname;

    window.onbeforeunload = function pushRefresh() {
      window.scrollTo(0, 0);
    };
    
    // a11y: move focus to main after route change
    const main = document.getElementById('main');
    if (main) {
      // setTimeout ensures DOM updated
      setTimeout(()=>{ try { main.setAttribute('tabindex','-1'); main.focus(); } catch(_){} }, 0);
    }

  }, [location]);

  return (
    <Provider store = {store}>
      <Header/>
      <main id="main">
        <Routes>
          <Route path="/" element={<MainPage/>}/>

          {/* About */}
          <Route path="about">
            <Route index element={<DetailCompanyIntro/>} />
            <Route path="overview" element={<AboutOverview/>} />
            <Route path="history" element={<AboutHistory/>} />
          </Route>

          {/* Competency */}
          <Route path="competency">
            <Route index element={<Navigate to="/competency/hygateone" replace />} />
            <Route path="hygateone" element={<CompHyGateOne/>} />
            <Route path="maintenance" element={<CompMaintenance/>} />
            <Route path="process" element={<CompProcess/>} />
            <Route path="config" element={<CompConfig/>} />
          </Route>

          {/* Product */}
          <Route path="product">
            <Route index element={<Navigate to="/product/hygateone" replace />} />
            <Route path="hygateone" element={<ProductHyGateOne/>} />
            <Route path="scheduler" element={<ProductScheduler/>} />
            <Route path="rodcutting" element={<ProductRodCutting/>} />
          </Route>

          {/* Recruit */}
          <Route path="recruit">
            <Route index element={<Recruit/>} />
            <Route path="plan" element={<RecruitPlan/>} />
          </Route>

          {/* Support */}
          <Route path="support">
            <Route index element={<Navigate to="/support/notice" replace />} />
            <Route path="notice" element={<Notice/>} />
            <Route path="location" element={<Location/>} />
            <Route path="news" element={<SupportNews/>} />
            <Route path="questions" element={<SupportQuestions/>} />
          </Route>

          {/* Legacy redirects */}
          <Route path="notice" element={<Navigate to="/support/notice" replace />} />
          <Route path="location" element={<Navigate to="/support/location" replace />} />
          <Route path="rodcutting" element={<Navigate to="/product/rodcutting" replace />} />
          <Route path="about/greeting" element={<Navigate to="/about/overview" replace />} />
          <Route path="about/business" element={<Navigate to="/about/overview" replace />} />
          <Route path="competency/direction" element={<Navigate to="/competency/maintenance" replace />} />
          <Route path="competency/strategy" element={<Navigate to="/competency/maintenance" replace />} />
          <Route path="competency/service" element={<Navigate to="/competency/maintenance" replace />} />

          <Route path="article"  element={<BoardArticle/>} />
          <Route path="rodCuttingAlgo" element={<RodCuttingAlgo/>} />
        </Routes>
      </main>
      <Footer/>
    </Provider>
  );
}

export default App;
